import { CAMPAIGN_STATUSES } from '../model/campaign'
import type { CampaignStatus } from '../model/campaign'

/** Surface + ink for one status pill. */
const STATUS_TONE: Record<CampaignStatus, string> = {
  [CAMPAIGN_STATUSES.running]:
    'bg-campaign-running-surface text-campaign-running',
  [CAMPAIGN_STATUSES.scheduled]: 'bg-warm-50 text-gray-500',
  [CAMPAIGN_STATUSES.finished]: 'bg-green-50 text-campaign-done',
  [CAMPAIGN_STATUSES.paused]: 'bg-campaign-paused-surface text-campaign-paused',
  [CAMPAIGN_STATUSES.stopped]:
    'bg-campaign-stopped-surface text-campaign-stopped',
  [CAMPAIGN_STATUSES.draft]: 'bg-gray-100 text-gray-300',
}

export function campaignStatusTone(status: CampaignStatus): string {
  return STATUS_TONE[status]
}

export function campaignStatusLabelKey(status: CampaignStatus): string {
  return `campaigns.status.${status}`
}
